'use client'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { SearchItem } from '../types'

import { getLocationTypeByQuery } from '@/app/utils'
import * as Sentry from '@sentry/nextjs'

axiosRetry(axios, {
	retries: 3,
	retryDelay: (retryCount) => {
		console.log(`retry attempt: ${retryCount}`)
		return retryCount * 2000
	},
})

const sanitizeQuery = (query: string): string => {
	if (!query) return ''

	return query.replace(/&/g, ' ').replace(/\s+/g, ' ').trim()
}

export async function fetchAutocompleteResultsClient(
	query: string,
	language = 'en',
	country = 'EN'
): Promise<SearchItem[]> {
	const countryLanguageMap: any = {
		ar: 'SA',
		he: 'IL',
	}

	const languageMap: any = {
		ar: 'SA',
		he: 'iw',
	}
	const countryCode = countryLanguageMap[language] || language.toUpperCase()
	const langCode = languageMap[language] || language

	const sanitizedQuery = sanitizeQuery(query)

	try {
		const encodedQuery = encodeURIComponent(sanitizedQuery)

		const res = await axios.get<SearchItem[]>(
			`https://www.kayak.com/mvm/smartyv2/search?f=j&s=50&v=v1&lc=${langCode}&lc_cc=${countryCode}&where=${encodedQuery}`
		)

		return res.data
	} catch (e) {
		Sentry.init({
			dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
			debug: false,
			tracesSampleRate: 0,
			replaysOnErrorSampleRate: 0,
			replaysSessionSampleRate: 0,
			environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
		})
		Sentry.setContext('Request Params', {
			searchParams: JSON.stringify({ query, language, country }),
		})
		console.log('Error in Kayak Autocomplete:', e)
		Sentry.captureException(e)
	}

	return []
}

export const fetchLocationElasticSearchClient = async (
	query: string,
	lng = 'en'
) => {
	Sentry.init({
		dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
		debug: false,
		tracesSampleRate: 0,
		replaysOnErrorSampleRate: 0,
		replaysSessionSampleRate: 0,
		environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
	})

	try {
		const endpoint = getLocationTypeByQuery(query)

		Sentry.setContext('Request Query', {
			searchParams: JSON.stringify(query),
		})

		// This will now run in the browser and show up in Network tab
		const res = await axios.get(
			`${process.env.NEXT_PUBLIC_BACKEND_URL}/${endpoint}/${query}?lng=${lng}`
		)
		return res.data
	} catch (e: any) {
		console.log('Error in fetchLocationElasticSearchClient:', e)
		Sentry.captureException(`Error in FetchByDestcode: ${e.message}`)
	}

	return null
}
